import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import { BaseLayout } from '../../layouts'
import { InvoicesPage, UpcomingInvoicePage } from '.'

const InvoiceRouter = (): React.ReactElement => {
  const { path } = useRouteMatch()

  return (
    <BaseLayout>
      <Switch>
        <Route path={`${path}`} exact>
          <InvoicesPage />
        </Route>
        <Route exact path={`${path}/upcoming`}>
          <UpcomingInvoicePage />
        </Route>
      </Switch>
    </BaseLayout>
  )
}

export default InvoiceRouter
